import type FormHandler from '../../../forms/FormHandler';
import { FormValidationErrorResponse } from '../../types';

const wrapper = (formHandler: FormHandler) => ({
  handle: async ({ validationResult } : FormValidationErrorResponse) => {
    formHandler.processValidationResults(validationResult, formHandler.validationOptions);
  },
});

export default wrapper;
